import { render, staticRenderFns } from "./ColorForm.vue?vue&type=template&id=58aa7880&"
import script from "./ColorForm.vue?vue&type=script&lang=js&"
export * from "./ColorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports